import type { CommonSlice } from '../bs/common'

/**
 * Croatian overrides for the shared strings.
 *
 * *poslužitelj* rather than *server*, *ponovno* rather than *ponovo*, and
 * *pričekajte* rather than *sačekajte*. `error.notFound` and `error.forbidden`
 * are deliberately absent — they are word-for-word the same in both standards,
 * and repeating them here would create a second place to edit one sentence.
 */
export const common: Partial<CommonSlice> = {
  'error.offline': 'Nema veze s poslužiteljem. Provjerite internetsku vezu.',
  'error.sessionExpired': 'Sesija je istekla. Prijavite se ponovno.',
  'error.tooManyRequests': 'Previše zahtjeva. Pričekajte trenutak.',
  'error.server': 'Greška na poslužitelju. Pokušajte ponovno.',

  'action.retry': 'Pokušaj ponovno',
  'action.edit': 'Uredi',

  'state.saving': 'Spremanje…',
  'state.saved': 'Spremljeno.',
  'action.save': 'Spremi',

  // *upute* rather than *uputstvo*, as everywhere else in this locale.
  'help.readMore': 'Detaljnije u uputama →',

  // *nespremljeni* rather than *nesačuvani*, following `action.save` above.
  // `version.label` is *Verzija* in all three and is deliberately not repeated.
  'update.consequence':
    'Osvježite kada završite ono što radite — nespremljeni unosi na ovom ekranu se gube, a prijave u redu čekanja ostaju.',

  // *spremiti* rather than *sačuvati*, *poslana* rather than *poslata*.
  'queue.sent.one': 'Spremljena prijava je poslana.',
  'queue.sent.few': 'Poslane su {count} spremljene prijave.',
  'queue.sent.many': 'Poslano je {count} spremljenih prijava.',

}
